import { motion } from "framer-motion";
import { BookOpen, Printer, MailCheck } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";
import { BENEFITS } from "@/data/content";
import { Reveal } from "./Reveal";

const ICONS = { BookOpen, Printer, MailCheck };

export const Benefits = () => (
  <section id="korzysci" data-testid="benefits-section" className="py-24 lg:py-32 px-5 sm:px-8 bg-white">
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <p className="text-sm tracking-widest uppercase text-violet-deep font-600">Co zyskujesz</p>
        <h2 className="mt-4 font-display font-700 text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-ink max-w-2xl">
          Praktyczna wiedza i strategie, które możesz wdrożyć od razu.
        </h2>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {BENEFITS.map((b, i) => {
          const Icon = ICONS[b.icon];
          return (
            <Reveal key={i} delay={i * 0.1}>
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 300, damping: 22 }}
                className="h-full rounded-[1.75rem] bg-cream border border-ink/5 p-8"
              >
                <div className="grid place-items-center h-14 w-14 rounded-2xl bg-violet/15 text-violet-deep mb-6">
                  <Icon size={26} strokeWidth={1.6} />
                </div>
                <h3 className="font-display font-600 text-2xl text-ink">{b.title}</h3>
                <p className="mt-3 text-ink/55 leading-relaxed">{b.body}</p>
              </motion.div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
